<button
  class="btn"
  [type]="type"
  [ngClass]="[
    classes,
    variant === 'primary' ? 'btn-primary' : '',
    variant === 'theme' ? 'button dark' : '',
    variant === 'dark' ? 'theme-dark' : '',
    variant === 'danger' ? 'btn-danger' : '',
    variant === 'link'
      ? 'text-dark font-size-primary text-decoration-underline'
      : '',
    variant === 'text' ? 'btn-text' : '',
    variant === 'outline-dark' ? 'btn-outline-dark' : '',
    variant === 'secondary' ? 'btn-secondary-action' : '',
    variant === 'secondary-brand' ? 'btn-secondary-brand' : '',
    size === 'large' ? 'btn-lg' : '',
    size === 'medium' ? 'btn-md' : '',
    size === 'small' ? 'btn-sm' : '',
  ]"
  [disabled]="disabled"
  [ngStyle]="customStyles"
  [attr.data-testid]="dataTestid"
>
  <!-- Icons render through app-icon like everywhere else; 'icon fa' keeps
       the slot marker class and the FA4 base prefix for bare "fa-*" strings.
       NOTE: the <i> now lives in app-icon's view — every rule targeting it
       in button.component.scss must pierce with ::ng-deep. -->
  <app-icon *ngIf="startIcon" [icon]="'icon fa ' + startIcon"></app-icon>
  <ng-content></ng-content>
  <app-icon *ngIf="endIcon" [icon]="'icon fa ' + endIcon"></app-icon>
</button>
